module.exports = __webpack_public_path__ + "static/marcel-96021e839427e41e42eac42ccb980c0a.png";